import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PusherNotificationItem } from "../../models/PusherNotification.model";

interface PusherNotificationsState {
  items: PusherNotificationItem[];
}

const initialState: PusherNotificationsState = {
  items: [],
};

const pusherNotificationsSlice = createSlice({
  name: "pusherNotifications",
  initialState,
  reducers: {
    pushPusherNotification: (
      state,
      action: PayloadAction<PusherNotificationItem>,
    ) => {
      const mapped = action.payload;
      const filtered = state.items.filter((item) => {
        if (mapped.id && item.id === mapped.id) {
          return false;
        }

        if (mapped.messageId && item.messageId === mapped.messageId) {
          return false;
        }

        return true;
      });

      state.items = [mapped, ...filtered].slice(0, 5);
    },
    removePusherNotification: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(
        (item) =>
          item.id !== action.payload && item.messageId !== action.payload,
      );
    },
  },
});

export const { pushPusherNotification, removePusherNotification } =
  pusherNotificationsSlice.actions;

export default pusherNotificationsSlice.reducer;
